// @flow
import React from 'react';
import { FlexRow } from 'styles/Layout';
import styled from 'styled-components';
import { HeaderIcons } from 'utils/ExportCommon';
import { media } from 'styles/Mixins';

const Wrapper = styled(FlexRow)`
  position: sticky;
  min-height: 55px;
  height: 55px;
  width: 100%;
  top: 0;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  padding: 0 21px;
  z-index: 99;
  cursor: pointer;
  ${media.sm`
    padding: 0 56px;
    min-height: 60px;
    height: 60px;
  `};
`;

const Logo = styled(HeaderIcons.LogoSVG)`
  height: 30px;
  width: 88px;
`;
type PropsType = { history: any };

export default function Header(props: PropsType) {
  return (
    <Wrapper
      justifyContent="flex-end"
      alignItems="center"
      onClick={() => props.history.push('/')}
    >
      <Logo />
    </Wrapper>
  );
}
